import { Animation, Colors, Icon, Link, Tooltip, Typography, } from '@zapier/design-system';
import { createUniqueClassName } from '../../utils/createUniqueClassName';
import { useUniversalNavContext } from '../../hooks';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
const tooltipClassName = createUniqueClassName('UniversalNavLink', 'tooltip');
const tooltipSelector = `.${tooltipClassName}`;
const navIconClassName = createUniqueClassName('UniversalNavLink', 'navIcon');
const navIconSelector = `.${navIconClassName}`;
const externalIconClassName = createUniqueClassName('UniversalNavLink', 'externalIcon');
const externalIconSelector = `.${externalIconClassName}`;
const Styles = labelStyles('UniversalNavLink', {
    root: (props, hasBeforeText) => [
        withModifier('', Object.assign(Object.assign(Object.assign({}, Typography.paragraph3Medium), { color: Colors.neutral800, display: 'flex', position: 'relative', minHeight: 50, padding: 10, borderRadius: 3, whiteSpace: 'nowrap', width: '100%', transition: `${Animation.transitionValue}, font-weight 0s`, textDecoration: 'none', '&:hover, &:focus': {
                transition: 'none',
                color: Colors.neutral800,
                backgroundColor: Colors.neutral200,
                outline: 'none',
            }, [navIconSelector]: {
                color: Colors.neutral600,
            }, [`&:hover ${navIconSelector}, &:focus ${navIconSelector}`]: {
                transition: 'none',
                color: Colors.neutral800,
            } }), (props.isSidebar && Object.assign(Object.assign({}, Typography.paragraph3Medium), { borderRadius: 15, color: Colors.neutral700, outline: 'solid 2px transparent', '&:hover, &:focus': {
                transition: 'none',
                backgroundColor: Colors.cream,
                outline: `solid 2px transparent`,
            }, '&:focus': Object.assign(Object.assign({}, Typography.paragraph3Bold), { outlineOffset: '-1px', outline: `solid 2px ${Colors.brand}` }), [navIconSelector]: {
                color: Colors.neutral800,
            }, [`&:hover ${navIconSelector}, &:focus ${navIconSelector}`]: {
                transition: 'none',
            } })))),
        !hasBeforeText &&
            withModifier('textOnly', {
                paddingLeft: 15,
                paddingRight: 15,
            }),
        props.isSelected &&
            withModifier('selected', Object.assign(Object.assign(Object.assign({}, Typography.paragraph3Bold), { color: Colors.blue, backgroundColor: Colors.blue10, [navIconSelector]: {
                    color: Colors.blue,
                } }), (props.isSidebar && {
                color: Colors.neutral800,
                backgroundColor: Colors.cream,
                [navIconSelector]: { color: Colors.brand },
            }))),
        props.isCollapsed &&
            withModifier('collapsed', {
                width: 50,
            }),
        {
            [tooltipSelector]: {
                opacity: 0,
                pointerEvents: 'none',
                transition: 'opacity 0.1s ease-in-out',
                '@media (hover: none)': {
                    display: 'none',
                },
            },
            [`&:hover ${tooltipSelector}, &:focus ${tooltipSelector}`]: {
                opacity: 1,
                pointerEvents: 'auto',
            },
        },
        {
            [externalIconSelector]: {
                opacity: 0,
            },
            [`&:hover ${externalIconSelector}, &:focus ${externalIconSelector}`]: {
                opacity: 0.5,
            },
        },
    ],
    layout: {
        display: 'grid',
        gridTemplateColumns: 'auto minmax(0, 1fr) auto',
        gap: 20,
        alignItems: 'center',
        overflow: 'hidden',
        width: '100%',
    },
    text: {
        '&[aria-hidden="true"]': {
            opacity: 0,
        },
    },
});
const UniversalNavLink = (props) => {
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const tooltip = props.isCollapsed && (isolateComponent("span", { className: tooltipClassName },
        isolateComponent(Tooltip, { position: "east" }, props.text)));
    const onClick = (e) => {
        e.currentTarget.blur();
        if (props.onClick) {
            props.onClick(e);
        }
    };
    const beforeText = props.renderBeforeText && props.renderBeforeText(props);
    return (isolateComponent(Link, { color: null, css: Styles.root(props, !!beforeText), href: getFullyQualifiedURL(props.href), onClick: onClick, role: props.role, target: props.target || '_self' },
        isolateComponent("span", { css: Styles.layout },
            beforeText,
            isolateComponent("span", { "aria-hidden": props.isCollapsed, css: Styles.text }, props.text),
            props.isExternal && !props.isCollapsed && (isolateComponent("span", { className: externalIconClassName },
                isolateComponent(Icon, { isBlock: true, name: "arrowOffsite", size: 18 })))),
        tooltip));
};
UniversalNavLink.defaultProps = {
    isCollapsed: false,
    isExternal: false,
    isSelected: false,
    renderBeforeText: (props) => props.icon && (isolateComponent("span", { className: navIconClassName },
        isolateComponent(Icon, { isBlock: true, name: props.icon, size: 30 }))),
};
export default UniversalNavLink;
//# sourceMappingURL=UniversalNavLink.js.map
// @zapier/universal-layout@7.13.18 (4fa0201da)
